package org.moxultimate.topwithmox.tech.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * TechTagResponse
 * Data class representing a single tag entry returned by GET /tech-tag.
 *
 * @param id  Unique database identifier of the tag.
 * @param tag Tag label string (e.g. "Kotlin", "Android", "Backend").
 */
@Serializable
data class TechTagResponse(
    @SerialName("id") val id: Long? = null,
    @SerialName("tag") val tag: String? = null,
)
